import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=372d2ad5&scoped=true"
import script from "./problem.vue?vue&type=script&lang=js"
export * from "./problem.vue?vue&type=script&lang=js"
import style0 from "./problem.vue?vue&type=style&index=0&id=372d2ad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d2ad5",
  null
  
)

export default component.exports